export default __webpack_public_path__ + "static/media/scorecard-tile.72229d39.png";